import actionTypes from '../constants/action-types';

const hide = (elements) => ({
  type: actionTypes.HIDE,
  payload: {
    elements,
  },
});

export default hide;
